<template>
  <div>
    <el-dialog title="修改分类" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false" width="600px">

      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="分类名称">
          <el-input class="max-w460" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="分类图片：" :rules="[{ required: true, message: '请上传分类图片' }]" prop="imageId">
          <el-row>
            <div class="draggable-list">
              <div class="item img-select" v-if="form.imageId==0" @click="openProductUpload('image', 'course_image')">
                <i class="el-icon-plus"></i>
              </div>
              <div v-if="form.imageId!=0" class="item" @click="openProductUpload('image', 'course_image')">
                <img :src="form.images.filePath" width="100" height="100" />
              </div>
            </div>
          </el-row>
        </el-form-item>
        <!-- <el-form-item label="父级ID">
          <el-input class="max-w460" v-model="form.parent_id" type="number"></el-input>
        </el-form-item> -->
        <el-form-item label="排序">
          <el-input class="max-w460" v-model="form.sort" type="number"></el-input>
        </el-form-item>
      </el-form>
      <!--图片组件-->
      <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="submit()" :disabled="submit_loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  props: ["open_edit", "form"],
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "180px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false,
      filePath: "",
      isProductUpload: false,
      file_name: "image"
    };
  },
  created() {
    this.dialogVisible = this.open_edit;
  },

  methods: {
    /*修改用户*/
    submit() {
      let self = this;
      let params = this.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          Technician.courseCategoryEdit(params, true)
            .then(data => {
              self.submit_loading = false;
              self.$message({
                message: "恭喜你，修改成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    },
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else if (fileType == "audio") {
        this.config = {
          total: 1,
          fileType: "audio"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传活动图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "course_image") {
          this.form.imageId = e[0].fileId;
          this.form.images.filePath = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    }
  }
};
</script>

<style scoped lang=''>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/train/center/courseclass/edit.vue